export const ENV_NAVIGATION_URL_PARAMS = {
	accessToken: 'accessToken',
	refreshToken: 'refreshToken',
	company: 'company',
	redirectUri: 'redirectUri', // instead of returnUrl (to be more explicit)
} as const;
export type ENV_NAVIGATION_URL_PARAMS = (typeof ENV_NAVIGATION_URL_PARAMS)[keyof typeof ENV_NAVIGATION_URL_PARAMS];

/**
 * 'returnUrl' is the parameter used to redirect the user inside the app/target env. (after login)
 */
export const RETURN_URL_PARAM = 'returnUrl' as const;

export const REDIRECTION_PAGE = 'redirect' as const;

export type EnvironmentRedirectUrlWithAuthParams = {
	[ENV_NAVIGATION_URL_PARAMS.accessToken]: string;
	[ENV_NAVIGATION_URL_PARAMS.refreshToken]: string;
	[ENV_NAVIGATION_URL_PARAMS.company]: string;
	// optional (redirectUri only for navigation between environments, will be converted to returnUrl(RETURN_URL_PARAM) in target env)
	[ENV_NAVIGATION_URL_PARAMS.redirectUri]?: string;
};

export type EnvironmentRedirectUrlParams = {
	[ENV_NAVIGATION_URL_PARAMS.redirectUri]: string;
};

export type ValidEnvironmentUrlParams = EnvironmentRedirectUrlWithAuthParams | EnvironmentRedirectUrlParams | null;

export function isEnvironmentRedirectUrlWithAuthParams(urlParams: object): urlParams is EnvironmentRedirectUrlWithAuthParams {
	return !!urlParams && !!urlParams[ENV_NAVIGATION_URL_PARAMS.accessToken] && !!urlParams[ENV_NAVIGATION_URL_PARAMS.refreshToken] && !!urlParams[ENV_NAVIGATION_URL_PARAMS.company];
}

export function isEnvironmentRedirectUrlParams(urlParams: object): urlParams is EnvironmentRedirectUrlParams {
	return !!urlParams && !urlParams[ENV_NAVIGATION_URL_PARAMS.accessToken] && !urlParams[ENV_NAVIGATION_URL_PARAMS.refreshToken] && !!urlParams[ENV_NAVIGATION_URL_PARAMS.redirectUri];
}

/** ------------------------------------ ------------------------------------ */
/**
 * NavigationCheckResult is the result of the checkRedirectUrlStructure function.
 * - replaceHref: replace the current URL with the new one (without saving the current URL in history) - force redirect using window.location.replace
 * - navigate: navigate to the given path using angular router
 * - error: there was an error in the URL, show an error message
 */
export type NavigationCheckResult = {
	replaceHref: URL | undefined;
	navigate: string[] | undefined;
	error: string | undefined;
};
